var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarn = function SvgEarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "earn_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.07.563h50v50h-50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#earn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.248 40.302v8.307s-6.312 2.589-10.465 1.672 6.042-9.98 10.465-9.98Z",
    fill: "#171836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.698 31.076c.431 1.78 1.618 4.316-2.32 5.287.432 2.48.702 4.1-3.398 4.639-4.1.539-13.593-.216-16.452 2.103-2.859 2.32-2.697 7.174-4.1 7.39-1.402.216-8.037 0-10.248-1.996V37.82s-5.772-4.1-4.855-9.224c.917-5.124 8.523-11.49 8.523-11.49s1.942-1.941 3.56-3.128c.755-.54 1.456-.97 1.834-.917.97.162 2.913 1.025 2.104 3.938a7.95 7.95 0 0 1-.756 1.78c-2.319 4.37-4.53 6.958-1.995 7.12 2.535.162 15.75-.485 15.75-.485s12.73-.216 13.917 1.402c1.187 1.672.81 3.398-1.564 4.261Z",
    fill: "#AD5BB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.436 37.119c-.108 0-.162-.054-.216-.162a.284.284 0 0 1 .108-.378c.054 0 2.157-1.348 2.48-7.605 0-.162.163-.27.27-.27.162 0 .27.162.27.27-.377 6.634-2.643 7.983-2.75 8.037-.055.108-.108.108-.162.108Z",
    fill: "#851A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.697 31.347-14.834-.432c-.161 0-.27-.107-.27-.27 0-.161.163-.269.27-.269l14.834.431c.162 0 .27.108.27.27 0 .162-.108.27-.27.27ZM42.38 36.634l-13.755-.701c-.162 0-.27-.108-.27-.27 0-.162.162-.27.27-.27l13.701.702c.162 0 .27.108.27.27.054.161-.054.27-.216.27ZM19.452 35.554h-.054c-.162-.053-.216-.215-.162-.323 1.618-5.179-1.726-8.847-1.78-8.9a.26.26 0 0 1 0-.378.26.26 0 0 1 .378 0c.053.054 3.614 3.884 1.887 9.386-.053.162-.161.215-.27.215ZM12.492 17.052c-.216 0-.324-.108-.324-.27 0-.162.108-.27.27-.27.162 0 3.452.108 4.153-3.182.054-.162.162-.216.324-.216.162.054.216.162.216.324-.702 3.506-4.208 3.614-4.64 3.614Z",
    fill: "#851A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.29 17.053c-.324-.432-.54-1.025-.54-1.403 0-.863-.215-.593-2.05-.485-1.024.054-1.24-.54-1.294-1.133.755-.54 1.457-.971 1.834-.917.917.216 2.86 1.025 2.05 3.938Z",
    fill: "#171836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.932 23.957h-17.1a.54.54 0 0 1-.539-.539v-9.547c0-.324.27-.54.54-.54h17.099c.323 0 .539.27.539.54v9.547c0 .27-.27.54-.54.54Z",
    fill: "#FEA542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.007 14.409H16.758a.54.54 0 0 1-.54-.54V9.717c0-.323.27-.54.54-.54h23.249c.323 0 .539.27.539.54v4.154a.54.54 0 0 1-.54.539Z",
    fill: "#F5B826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.298 9.663h-3.884V24.12h3.884V9.663Z",
    fill: "#7A1586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41 10.04c-.054 0-.108 0-.162-.053-4.154-1.51-6.311-3.56-6.635-6.365-.162-1.295.54-2.374 1.672-2.859 1.079-.432 2.59-.216 3.614 1.133 1.564 2.103 2.05 7.336 2.05 7.551 0 .162-.054.378-.216.486-.108.108-.216.108-.323.108Zm-4.046-8.36c-.216 0-.486.054-.701.108-.701.27-1.08.917-.971 1.726.215 2.158 1.888 3.83 5.07 5.124-.216-1.564-.701-4.692-1.726-6.095-.485-.593-1.133-.863-1.672-.863Z",
    fill: "#7A1586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10.634c-3.183 0-6.528-2.536-6.743-2.697-.216-.162-.27-.54-.108-.756.162-.215.54-.27.755-.107.054.054 4.962 3.775 7.93 1.995.269-.161.593-.054.754.162.162.27.054.594-.161.755a4.962 4.962 0 0 1-2.428.648Z",
    fill: "#7A1586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.41 9.339c-.323 0-.539-.216-.539-.54 0-.161-.054-3.775 2.212-5.232 1.348-.917 2.75-.431 3.56.378.809.863.917 1.996.27 2.805-1.187 1.456-3.56 2.589-5.502 2.589Zm3.183-5.178c-.27 0-.593.108-.97.323-1.295.863-1.619 2.751-1.673 3.722 1.51-.215 3.183-1.079 4.046-2.157.323-.432.107-.971-.216-1.349a1.546 1.546 0 0 0-1.187-.54Z",
    fill: "#7A1586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.378 10.365c-1.079 0-2.211-.324-3.344-1.133-.27-.162-.324-.54-.108-.755.162-.27.54-.324.755-.108 1.618 1.187 3.399 1.24 5.34.162 1.457-.809 2.482-2.05 2.482-2.05.215-.215.54-.27.755-.054.216.216.27.54.054.756-1.079 1.348-3.344 3.182-5.934 3.182Z",
    fill: "#7A1586"
  }))));
};

export default SvgEarn;